import { resolveThemeLayout } from "@lumora/core";
/** Precedence: URL query -> env -> config defaults (see `resolveThemeLayout`). */
export function resolveSiteVariant(options, src = {}) {
    // `variant` is a legacy theme query key some restaurant sites still use.
    return resolveThemeLayout(src, { ...options, themeQueryKeys: ["theme", "variant"] });
}
/** True when the package tier includes owner/staff sign-in surfaces. */
export function packageShowsOwnerNav(ownerNav, pkg) {
    const tier = (pkg ?? ownerNav.defaultTier).toLowerCase();
    return ownerNav.tiers.some((t) => t.toLowerCase() === tier);
}
/**
 * Template-sibling sites differ only in which themes and layouts they ship. Query
 * precedence is URL (`theme`, `layout`) then env then default, as `resolveThemeLayout`.
 */
export function createSiteVariant(options) {
    return {
        THEMES: options.themes,
        LAYOUTS: options.layouts,
        DEFAULT_THEME: options.defaultTheme,
        DEFAULT_LAYOUT: options.defaultLayout,
        resolveVariant: (src = {}) => resolveThemeLayout(src, options),
    };
}
/** Owner-nav tiers shared by the connect+ template siblings. */
export const TEMPLATE_OWNER_NAV = { tiers: ["connect", "commerce", "custom"], defaultTier: "brand" };
//# sourceMappingURL=variant.js.map